import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard as Auth0Guard } from '@auth0/auth0-angular';
import { SearchGuard } from '@techspert-io/auth';
import { OmnisearchPageComponent } from '@techspert-io/omnisearch';
import { DashboardGuard } from './features/auth/guards/dashboard.guard';
import { ReportsGuard } from './features/auth/guards/reports.guard';
import { EditSheetComponent } from './features/data-capture/components/edit-sheet/edit-sheet.component';
import { SheetGetStartedComponent } from './features/data-capture/components/sheet-get-started/sheet-get-started.component';
import { PrivateComponent } from './private/private.component';
import { OpportunityComponent } from './public/opportunity/opportunity.component';
import { LandingPageComponent } from './shared/components/landing-page/landing-page.component';
import { NotAuthorizedComponent } from './shared/components/not-authorized/not-authorized.component';

const routes: Routes = [
  {
    path: 'secure',
    component: PrivateComponent,
    canActivate: [Auth0Guard],
  },
  {
    path: 'connect',
    canActivate: [Auth0Guard],
    children: [
      {
        path: ':id/settings',
        loadComponent: () =>
          import('./public/opportunity/opportunity-settings/opportunity-settings.component').then(
            (m) => m.OpportunitySettingsComponent
          ),
      },
      {
        path: ':id/settings/interview-period',
        loadComponent: () =>
          import('./features/interview-period/components/dashboard/interview-period-dashboard.component').then(
            (m) => m.InterviewPeriodDashboardComponent
          ),
      },
      {
        path: ':id/:projectCode',
        component: OpportunityComponent,
      },
      {
        path: ':id',
        component: OpportunityComponent,
      },
      {
        path: 'data-capture/:publicDisplayId/:sheetId/edit',
        component: EditSheetComponent,
      },
      {
        path: 'data-capture/:publicDisplayId/new-sheet',
        component: SheetGetStartedComponent,
      },
    ],
  },
  {
    path: 'search',
    component: OmnisearchPageComponent,
    canActivate: [Auth0Guard, SearchGuard],
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./features/client-reports/client-reports.module').then(
        (m) => m.ClientReportsModule
      ),
    canActivate: [Auth0Guard, ReportsGuard],
  },
  {
    path: 'call-complete',
    loadChildren: () =>
      import('./features/call-actions/call-actions.module').then(
        (m) => m.CallActionsModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [Auth0Guard, DashboardGuard],
  },
  { path: 'not-authorized', component: NotAuthorizedComponent },
  {
    path: 'not-found',
    component: LandingPageComponent,
  },
  { path: '**', redirectTo: 'search' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
